<template>
  <!-- 整個產品仍在 beta：掛在品牌旁（側欄、手機頂欄、登入頁），所有環境都顯示 -->
  <UBadge color="warning" variant="solid" size="sm" class="shrink-0 font-semibold tracking-wide">
    {{ t('common.beta') }}
  </UBadge>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
